import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["originalId", "title", "promoImage", "coverImageUrl", "url", "professor", "prices", "discount", "imagePlaceholder", "imagePlaceholderUrl", "nextDiscount"];
import { notEmpty } from "@crehana/utils";
var TYPE = /*#__PURE__*/function (TYPE) {
  TYPE["COURSE"] = "COURSE";
  TYPE["BUNDLE"] = "BUNDLE";
  return TYPE;
}(TYPE || {});
export var transformItem = function transformItem(type) {
  return function (_ref) {
    var bundleId = _ref.originalId,
      title = _ref.title,
      promoImage = _ref.promoImage,
      coverImageUrl = _ref.coverImageUrl,
      url = _ref.url,
      professor = _ref.professor,
      pricesNode = _ref.prices,
      discount = _ref.discount,
      imagePlaceholder = _ref.imagePlaceholder,
      imagePlaceholderUrl = _ref.imagePlaceholderUrl,
      nextDiscount = _ref.nextDiscount,
      rest = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread(_objectSpread(_objectSpread({}, rest), {}, {
      type: type,
      id: "".concat(bundleId).concat(type),
      originalId: bundleId,
      title: title,
      url: url,
      image: promoImage || coverImageUrl,
      imagePlaceholder: imagePlaceholder || imagePlaceholderUrl,
      professor: professor,
      discount: discount
    }, pricesNode), {}, {
      prices: pricesNode,
      promoImage: promoImage,
      nextDiscount: nextDiscount
    });
  };
};
export var parseData = function parseData(_ref2) {
  var prices = _ref2.prices,
    totalDiscount = _ref2.totalDiscount,
    originalId = _ref2.originalId,
    shoppingCartDetailBundlesSet = _ref2.shoppingCartDetailBundlesSet,
    shoppingCartDetailCoursesSet = _ref2.shoppingCartDetailCoursesSet,
    dataExtraDiscount = _ref2.dataExtraDiscount,
    nextDiscount = _ref2.nextDiscount,
    pricesWithCredit = _ref2.pricesWithCredit;
  var courseIdsInCart = [];
  var courses = (shoppingCartDetailCoursesSet === null || shoppingCartDetailCoursesSet === void 0 ? void 0 : shoppingCartDetailCoursesSet.edges.map(function (el) {
    return el === null || el === void 0 ? void 0 : el.node;
  }).filter(notEmpty).filter(function (el) {
    var _el$prices;
    return el.course && ((_el$prices = el.prices) !== null && _el$prices !== void 0 && _el$prices.price ? el.prices.price > 0 : false);
  }).map(function (c) {
    var _categoryObj, _subCategory;
    courseIdsInCart.push(c.course.originalId);
    return _objectSpread(_objectSpread({}, c.course), {}, {
      categoryName: (_categoryObj = c.course.categoryObj) === null || _categoryObj === void 0 ? void 0 : _categoryObj.name,
      subcategoryName: (_subCategory = c.course.subCategory) === null || _subCategory === void 0 ? void 0 : _subCategory.name,
      prices: c.prices
    });
  })
  // @ts-expect-error This function is not well typed
  .map(transformItem(TYPE.COURSE)).map(function (c) {
    var extraDiscountItem = dataExtraDiscount ? dataExtraDiscount.find(function (i) {
      return (i === null || i === void 0 ? void 0 : i.id) === c.originalId;
    }) : null;
    return _objectSpread(_objectSpread({}, c), {}, {
      extraDiscount: extraDiscountItem ? extraDiscountItem.percent : null
    });
  }).reverse()) || [];
  var bundleIdsInCart = [];
  var bundles = (shoppingCartDetailBundlesSet === null || shoppingCartDetailBundlesSet === void 0 ? void 0 : shoppingCartDetailBundlesSet.edges.map(function (el) {
    var _el$node;
    return el === null || el === void 0 ? void 0 : (_el$node = el.node) === null || _el$node === void 0 ? void 0 : _el$node.bundle;
  }).filter(notEmpty).map(function (b) {
    bundleIdsInCart.push(b.originalId);
    return b;
  })
  // @ts-expect-error This function is not well typed
  .map(transformItem(TYPE.BUNDLE)).reverse()) || [];
  return {
    nextDiscount: nextDiscount,
    cartSummary: {
      idCart: originalId,
      totalOff: totalDiscount,
      dataExtraDiscount: dataExtraDiscount,
      currencySymbol: prices === null || prices === void 0 ? void 0 : prices.currencySymbol,
      totalPrice: prices === null || prices === void 0 ? void 0 : prices.price,
      totalRealPrice: prices === null || prices === void 0 ? void 0 : prices.realPrice,
      totalPriceWithCredits: pricesWithCredit === null || pricesWithCredit === void 0 ? void 0 : pricesWithCredit.priceWithCredit,
      credit: pricesWithCredit === null || pricesWithCredit === void 0 ? void 0 : pricesWithCredit.credit
    },
    items: [].concat(_toConsumableArray(courses), _toConsumableArray(bundles)),
    bundles: bundles,
    courses: courses,
    courseIdsInCart: courseIdsInCart,
    bundleIdsInCart: bundleIdsInCart
  };
};